import './modules/modernizr-custom';
import Accordions from './modules/accordion';
import Modals from './modules/modal';
// import Tabs from './modules/tabs';
// import Includes from './modules/include';
import AnchorLink from './modules/anchorlink';
// import HashUrl from './modules/hash_url';
// import AgreeCheck from './modules/check';
// import './modules/carousel';
import Zaiko from './modules/zaiko';
// import Gift from './modules/gift';
// import ColorCart from './modules/colorcart';
// import SetCart from './modules/setcart';
// import Review from './modules/review';
// import './modules/scroll-effect';
// import './modules/timer';
// import './modules/intersection-observer';

// YouCamメイクシミュレーター
// import YouCam from './modules/youcam';

// // API読み込み
// (function (d,k) {
//   var s = d.createElement('script');
//   s.type = 'text/javascript';
//   s.async = true;
//   s.src = 'https://plugins-media.makeupar.com/c317/sdk.js?apiKey=' + k;
//   var x = d.getElementsByTagName('script')[0];
//   x.parentNode.insertBefore(s, x);
// })(document, 'y6xyy2zXnvV8pqT4m49JQ==')
// // ツール初期化
// window.ymkAsyncInit = function() {
//   YMK.init({'autoOpen': true,'language': 'jpn'});
//   window.YMK.addEventListener('loaded', function() {
//     const vmModal = document.getElementById('modal-vm');
//     if(vmModal){
//       const envBox = vmModal.querySelector('.mod-vmmodal--vmcont_env');
//       const vmBtnBox = vmModal.querySelector('.mod-vmmodal--vmcont_function');
//       envBox.style.display = 'none';
//       vmBtnBox.style.display = 'block';
//     }
//   });
// }
// //YouCamメイクシミュレーター

document.addEventListener('DOMContentLoaded',function(){

  //html include
  // const includeContainers = Array.from(document.querySelectorAll('[data-inc]'));
  // includeContainers.forEach((container) => {
  //   new Includes(container);
  // });

  //在庫制御
  const carts = document.querySelectorAll('.js-zaiko');
  const zaikoFlag = 'zaiko-completed';
  const zaikocb = function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if(!entry.target.classList.contains(zaikoFlag)){
          new Zaiko(entry.target);
          entry.target.classList.add(zaikoFlag);
        }
        observer.unobserve(entry.target);
      }
    });
  };
  const zaikoIOoptions = {
      root: null,
      rootMargin: "100px",
      threshold: 0
  };
  const zaikoio = new IntersectionObserver(zaikocb, zaikoIOoptions);
  if(carts){
    carts.forEach((cart,index) => {
      cart.setAttribute('data-zaiko_serial', index + 1);
      zaikoio.observe(cart);
    });
  }

  //ギフトカート
  // const giftCarts = document.querySelectorAll('.js-gift');
  // const giftCompleteFlag = 'gift-completed';
  // const giftCb = function (entries, observer) {
  //   entries.forEach(entry => {
  //     if (entry.isIntersecting) {
  //       if (!entry.target.classList.contains(giftCompleteFlag)) {
  //         new Gift(entry.target);
  //         entry.target.classList.add(giftCompleteFlag);
  //       }
  //       observer.unobserve(entry.target);
  //     }
  //   });
  // };
  // const giftIOoptions = {
  //   root: null,
  //   rootMargin: "100px",
  //   threshold: 0
  // };
  // const giftIO = new IntersectionObserver(giftCb, giftIOoptions);
  // if (giftCarts) {
  //   giftCarts.forEach((cart, index) => {
  //     cart.setAttribute('data-gift_serial', index + 1);
  //     giftIO.observe(cart);
  //   });
  // }

  // レビューAPI
  // const reviewCont = Array.from(document.querySelectorAll('.js-review'));
  // reviewCont.forEach((cont) => {
  //   new Review(cont);
  // });

  //Accordion
  const accordionArray = Array.from(document.querySelectorAll('.js-acc'));
  accordionArray.forEach((accordion,index) => {
    accordion.setAttribute('data-accordion_serial', 'accordion_' + (index + 1));
    new Accordions(accordion);
  });

  //YouCamメイクシミュレーター
  // const vmModalBtns = Array.from(document.querySelectorAll('.js-vmmodal-open'));
  // vmModalBtns.forEach( (modalBtn, index) => {
  //   modalBtn.setAttribute('onclick', '_sc.gene_click(\'simulator_' + (index + 1) + '\',\'\');');
  //   new YouCam(modalBtn);
  // });

  //タブ切り替え
  // const tabsBtn = Array.from(document.querySelectorAll('.js-tabs-btn'));
  // tabsBtn.forEach((tabBtn) => {
  //   new Tabs(tabBtn);
  // });

  // 同意チェック
  // const checkboxs = Array.from(document.querySelectorAll('.js-agreecheck-input'));
  // checkboxs.forEach((check) => {
  //   new AgreeCheck(check);
  // })

  window.addEventListener('load',function(){

    //Modal window
    const modalArray = Array.from(document.querySelectorAll('.mod-modal'));
    modalArray.forEach( (modal) => {
      new Modals(modal);
    });
    const modalOpenButtonArray = Array.from(document.querySelectorAll('.js-modal-open'));
    modalOpenButtonArray.forEach((button,index) => {
      button.setAttribute('onclick', "_sc.gene_click('modal_" + (index + 1) + "','');");
    });

    // 色玉在庫制御
    // const colorCarts = Array.from(document.querySelectorAll('.js-colorcart-irodama'));
    // colorCarts.forEach((irodamabtn,index) => {
    //   irodamabtn.setAttribute('data-colorcart_serial', index + 1);
    //   new ColorCart(irodamabtn);
    // });

    // 複数商品選択カート
    // const setCarts = Array.from(document.querySelectorAll('.js-setcart'));
    // setCarts.forEach((setCart,index) => {
    //   setCart.setAttribute('data-setcart_serial', index + 1);
    //   new SetCart(setCart);
    // });

    //smooth anchor
    // 上部固定要素があれば指定する
    // const fixedContent = document.querySelector('.mod-fixednav.m-upper');
    //ページ内リンク
    let anchorLinks = Array.from(document.querySelectorAll('a'));
    anchorLinks.forEach((link) => {
      // new AnchorLink(link,fixedContent);
      // fixedContentなしVersion
      new AnchorLink(link);
    });
    //ハッシュ付きURLでアクセス
    // new HashUrl(fixedContent);
    // fixedContentなしVersion
    // new HashUrl();
  });


  var fixedCart = $('.js-cart');
  var janParameter = '';
  var price = 0;
  var priceTaxin = '';
  var cartUrl = '';
  var lackprice ='';
  var janClick = '';

  $('.js-checkbtn-set').on('click',function(evt){
      evt.preventDefault();
      var unit;
      var thisJan = '';
      var JanList = '';
      var thisPrice = '';
      var thisZaiko = '';
      var thisClick = '';

      if($(this).hasClass('js-checkbtn-set')){

          unit = $(this).parent('.js-zaiko');
          thisJan = '&sweb_shohin_cd=' + unit.attr('data-shohincd');
          thisPrice = unit.attr('data-price');
          thisClick = '_' + unit.attr('data-shohincd');
          thisZaiko = unit.attr('data-zaiko');
          thisClick = '_' + unit.attr('data-shohincd');
          if($(this).hasClass('m-checked')){// すでにチェックが付いていたら削除
              $(this).removeClass('m-checked');
              price = parseInt(price) - parseInt(thisPrice);
              janParameter = String(janParameter.replace(thisJan, ''));
              janClick = String(janClick.replace(thisClick, ''));
              if(thisZaiko == 1) {
                  $(this).html('カートに入れる');
              }else if(thisZaiko == 2) {
                  $(this).html('カートに入れる<span>（残りわずか）</span>');
              }
          }else{//　チェックが付いていなかったら追加
              $(this).addClass('m-checked');
              price = parseInt(price) + parseInt(thisPrice);
              janParameter += String(thisJan);
              janClick += String(thisClick);
          }
      }

      priceTaxin = parseInt(price*1);
      if(parseInt(priceTaxin) >= 10){
        $('.cart_present').show();
        $('.js-cartLink').removeClass('empty');
      } else {
        $('.cart_present').hide();
        $('.js-cartLink').addClass('empty');
      }

      // console.log($('.cmn_gift').parent('.js-zaiko').attr('data-zaiko'));
      if (janClick.includes("4909978188269")||janClick.includes("4909978134969")||janClick.includes("4909978188153")||janClick.includes("4909978188160")||janClick.includes("4909978188177")) {
        document.querySelector('.text2').style.display = "block"; // 如果包含，显示元素
      } else {
        document.querySelector('.text2').style.display = "none"; // 否则，隐藏元素
      }

      if (janClick.includes("4909978188269")||janClick.includes("4909978134969")) {
        if (janClick.includes("4909978188153")||janClick.includes("4909978188160")||janClick.includes("4909978188177")) {
          document.querySelector('.text1').textContent = '500円クーポン 2枚プレゼント！';
          document.querySelector('.text2').style.display = "none";
        }else{
          document.querySelector('.text1').textContent = ' ';
        }
      }else if (janClick.includes("4909978188153")||janClick.includes("4909978188160")||janClick.includes("4909978188177")) {
        if (janClick.includes("4909978188269")||janClick.includes("4909978134969")) {
          document.querySelector('.text1').textContent = '500円クーポン 2枚プレゼント！';
          document.querySelector('.text2').style.display = "none";
        }else{
          document.querySelector('.text1').textContent = ' ';
        }
      }

      priceTaxin = String(Math.round(priceTaxin)).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      $('.js-totalPrice').text(priceTaxin);
      if(janParameter != ''){
        cartUrl = '/sw/products/SWFG070220.seam?actionMethod=/products%2FSWFG070220.xhtml%3AsWFG070220Action.addCartShohin' + janParameter + '&online_shohin_ctlg_kbn=1&keyword_flg=1';
        $('.js-cartLink').attr('href',cartUrl);
        var clickID = "cartbtn" + janClick;
        $('.js-cartLink').attr("onclick","_sc.gene_click('" + clickID + "','" + cartUrl +"');");

        if(fixedCart.hasClass('m-null')){
          fixedCart.removeClass('m-null');
          fixedCart.fadeIn(200);
        }
      }else{
        $('.js-cartLink').attr('href','#');
        if(!fixedCart.hasClass('m-null')){
          fixedCart.addClass('m-null');
          fixedCart.fadeOut(200);
        }
      }
  });

  function onClick(){
    var clickObj = $(".scClick");
    clickObj.each (function(){
      var clickID = $(this).attr("data-clickID");
      var clickLink = $(this).attr("href");
      $(this).attr("onclick","_sc.gene_click('" + clickID + "','" + clickLink +"');");
    })
  }
  onClick();

});
